module.exports = "<svg id=\"i-close\" viewBox=\"0 0 32 32\" width=\"32\" height=\"32\" fill=\"none\" stroke=\"currentcolor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"6.25%\">\n  <path d=\"M2 30 L30 2 M30 30 L2 2\" />\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/svg/close.svg
// module id = 75
// module chunks = 0